import { selector } from 'recoil';

import { Bugo } from '@shared/api/bugo/bugo.interface';
import { FeventWithAgencyBrand } from '@shared/api/fevent/fevent.interface';
import { Shop } from '@shared/api/shop/shop.interface';
import { QueryDataState } from '@shared/interfaces';

import { Member } from '../member/member.interface';
import { callOrderListDataAtom, callOrderListStatusAtom } from './callOrder.atom';
import { CallOrder } from './callOrder.interface';

export const sellerCallOrderListStateSelector = selector<
  QueryDataState<CallOrder<Bugo<string, FeventWithAgencyBrand, string, Member>, Shop>[]>
>({
  key: 'sellerCallOrderListStateSelector',
  get: ({ get }) => {
    return {
      status: get(callOrderListStatusAtom),
      data: get(callOrderListDataAtom),
    };
  },
});
